import Home from "./Home/Home";
import Doctor from "./Doctor/Doctor";
import Hospital from "./Hospital/Hospital";
import Signin from "./Identity/Signin/Signin";
import Signup from "./Identity/Signup/Signup";
import NotFound from "./404";
import { isArray } from "util";

const Routes = (titlePages: { id: string; title: string }[]) => {
  return isArray(titlePages) == true
    ? [
        {
          component: Home,
          path: "/home",
          title: titlePages?.find(id => id.id.match("home"))?.title || "روح",
        },
        {
          component: Doctor,
          path: "/doctor",
          title: titlePages?.find(id => id.id.match("doctors"))?.title || "روح",
        },
        {
          component: Hospital,
          path: "/hospital",
          title:
            titlePages?.find(id => id.id.match("hospitals"))?.title || "روح",
        },
        {
          component: Signin,
          path: "/signin",
          title: titlePages?.find(id => id.id.match("signin"))?.title || "روح",
        },
        {
          component: Signup,
          path: "/signup",
          title: titlePages?.find(id => id.id.match("signup"))?.title || "روح",
        },
        {
          component: NotFound,
          path: "/404",
          title: titlePages?.find(id => id.id.match("404"))?.title || "روح",
        },
      ]
    : [];
};

export default Routes;
